import { render, staticRenderFns } from "./FotoPendukungNonBaseFile.vue?vue&type=template&id=62fbd2b6&"
import script from "./FotoPendukungNonBaseFile.vue?vue&type=script&lang=js&"
export * from "./FotoPendukungNonBaseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports